import Core from "@/modules/core/service/Core";

const url = {
    userdata: "/api/user",
    since   : "/api/user/preferences/since?since={0}"
};

export default {
    store (userdata) {
        return Core.method.put(url.userdata, userdata);
    },

    updateResolvedSince (since) {
        return Core.method.put(url.since, null, since.id);
    }
}